export const EXTERNAL_EXIT_SURVEY_CODE = "external_exit_survey"

export function redirectToExternalExitSurvey(response, location = window.location) {
	const data = response && response.data
	if (!response || response.status !== 409 || !data || data.code !== EXTERNAL_EXIT_SURVEY_CODE) {
		return false
	}

	try {
		const redirectUrl = new URL(data.redirect_url)
		if (!["http:", "https:"].includes(redirectUrl.protocol)) {
			return false
		}

		location.replace(redirectUrl.toString())
		return true
	} catch (_error) {
		return false
	}
}
